<template>
  <v-col cols="12">
    <v-form ref="form" tag="form" name="form">
      <v-col column wrap>
        <v-col xs12 sm12 d-flex>
          <SiteSelect
            :site="magazine.site_key || $attrs.site_key"
            @site-selected="siteSelected"
          ></SiteSelect>
        </v-col>
        <v-col cols="12">
          <v-text-field
            label="Название"
            v-model="magazine.name"
            name="name"
            :rules="rules.required"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-textarea
            label="Описание"
            name="description"
            v-model="magazine.description"
          ></v-textarea>
        </v-col>
        <v-col cols="12" class="text-xs-center">
          <v-row wrap fill-height>
            <FileInput :url="magazine.image.url" @file-selected="imageSelected"></FileInput>
            <v-col lg6>
              <FileInput
                :url="magazine.image.url"
                @file-selected="pdfSelected"
                field-name="file"
                label="Выберите PDF файл"
                accept="application/pdf"
              >
              </FileInput>
            </v-col>
            <div v-if="isEdit">
              <a style="display: block; transform: translateY(50%)" :href="magazine.url"
                >Посмотреть PDF</a
              >
            </div>
          </v-row>
        </v-col>
      </v-col>
      <v-btn color="primary" @click="save">Сохранить</v-btn>
      <v-btn v-if="isEdit" color="error" @click="remove">Удалить</v-btn>
    </v-form>
  </v-col>
</template>

<script>
import SiteSelect from '@/components/SiteSelect'
import FileInput from '@/components/FileInput'
import api from '@/mixins/api'
import forms from '@/mixins/forms'

export default {
  name: 'magazine_create_update',
  components: { FileInput, SiteSelect },
  mixins: [api, forms],
  data() {
    return {
      pdfName: '',
      magazine: { url: '', image: { url: '' }, pdf: { url: '' } },
      pdf: { name: '' },
      image: { name: '' },
    }
  },
  computed: {
    isEdit() {
      return this.$route.name === 'magazines_edit'
    },
    cover() {
      if (this.isEdit) {
        return this.magazine.image ? this.magazine.image.url : ''
      } else {
        return this.image.url ? this.image.url : ''
      }
    },
  },
  mounted() {
    this.getSites()
    this.updateData()
  },
  methods: {
    siteSelected(e) {
      this.magazine.site_key = e.key
    },
    imageSelected(e) {
      this.image = e
      this.magazine.image.url = e.url
    },
    pdfSelected(e) {
      this.pdf = e
      this.magazine.url = e.url
    },
    save() {
      if (!this.isEdit) {
        const form = this.$refs.form
        if (!form.validate()) {
          this.showSnackbar('Заполните все необходимые поля', 'error')
          return
        }
        const data = new FormData(form.$el)
        this.axios({
          url: `/v1/magazines`,
          method: 'post',
          data: data,
        })
          .then((resp) => {
            this.showSnackbar('Сохранено', 'green')
            this.magazine = resp.data
            this.$router.push({ name: 'magazine_edit', params: { id: resp.data.id } })
          })
          .catch((err) => {
            this.$log.error('get magazine err', err, err.response.data)
            this.showSnackbar(err.response ? err.response.data : err, 'error')
          })
      } else {
        this.update()
      }
    },
    update() {
      const form = this.$refs.form
      const data = new FormData(form.$el)
      if (this.pdf.hasOwnProperty('file')) {
        data.append('file', this.pdf.file, this.pdf.name)
        this.$log.error('add file to request post', this.pdf)
      }

      if (this.image.hasOwnProperty('file')) {
        data.append('image', this.image.file, this.image.name)
      }
      this.axios({
        url: `/v1/magazines/${this.$route.params.id}`,
        method: 'patch',
        data: data,
      })
        .then((resp) => {
          this.magazine = resp.data
          this.showSnackbar('Сохранено', 'green')
        })
        .catch((err) => {
          this.$log.error('update magazine err', err, err.response)
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    updateData() {
      if (this.isEdit) {
        this.axios({
          url: `/v1/magazines/${this.$route.params.id}`,
          method: 'get',
        })
          .then((resp) => {
            this.magazine = resp.data
          })
          .catch((err) => {
            this.$log.error('get magazine err', err, err.response)
            this.$router.push({ name: 'magazines' })
          })
      } else {
        this.magazine.site_key = this.$route.params.site_key
      }
    },
    remove() {
      this.axios({
        url: `/v1/magazines/${this.$route.params.id}`,
        method: 'delete',
      })
        .then((resp) => {
          this.$router.push({ name: 'magazines' })
        })
        .catch((err) => {
          this.$log.error('get magazine err', err, err.response)
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
        .finally(() => {
          this.$router.push({ name: 'magazines' })
        })
    },
    onPdfPicked(e) {
      this.onFilePicked(e, (pdf) => {
        this.pdf = pdf
      })
    },
    onImagePicked(e) {
      this.onFilePicked(e, (im) => {
        this.image = im
        this.magazine.image.url = this.image.url
      })
    },
  },
}
</script>
